import {
    Button,
    Box,
    Typography,
    AppBar,
    IconButton,
    Toolbar,
    Divider
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Logo from '../assets/logo_garage.svg';
import theme from '../theme';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Notify from './Notify';

export default function Navbar({ user, setToken }) {

    // const { user } = useAppContext();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        setAnchorEl(null)
        navigate("/profile")
    }

    const handleTasks = () => {
        setAnchorEl(null)
        navigate("/")
    }

    const handleLogout = () => {
        setAnchorEl(null)
        sessionStorage.setItem('token', null)
        setToken(null)
        navigate("/")
    }

    return (
        <AppBar position="sticky" sx={{ backgroundColor: theme.palette.bar.main }}>
            <Toolbar>
                <Box sx={{ display: "flex", flexGrow: 1 }} >
                    <img src={Logo} alt="logo soft99 Garage" />
                    <Divider orientation="vertical" flexItem sx={{ ml: 1 }} />
                    <Typography component="h1" variant="overline" sx={{ ml: 1 }}>
                        PIA
                    </Typography>
                </Box>
                <Button aria-label="Zadania" onClick={() => navigate("/")} >
                    <FormatListBulletedIcon color='action' />
                </Button>
                {user && user.token && (
                    <Notify
                        user={user}
                    />
                )}
                {user && user.token && (
                    <div>
                        <Typography variant="subtitle1" component="div">{user.forname + " " + user.lastname}</Typography>
                    </div>
                )}

                {user && user.token && (
                    <div>

                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleTasks}>Zadania</MenuItem>
                            <MenuItem onClick={handleProfile}>Profil</MenuItem>
                            <MenuItem onClick={handleLogout}>Wyloguj</MenuItem>
                        </Menu>
                    </div>
                )}
            </Toolbar>
        </AppBar>
    );
}